import React, { Component, Fragment } from 'react';
import { Navigationmenu } from '../components';
import {
    Box,
    Button,
    Typography,
    Grid,
    TextField,
    IconButton,
    ButtonGroup,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    FormControl,
    Select,
    InputLabel,
    MenuItem,
    Popover,
    Dialog,
    Tabs,
    Tab,
    DialogActions,
    withStyles,
    AppBar, Toolbar
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

import {
    SearchOutlined,
    ArrowDropDown,
    Publish,
    NoteAdd,
    ArrowDropUp,
    InsertDriveFileOutlined,
    RepeatOneSharp
} from '@material-ui/icons';
import { FileCopy, Refresh, Add, Delete, Edit } from '@material-ui/icons';
// import { DataGrid } from '@material-ui/data-grid';
import circulargridimage from '../gallery/gridloader.gif';



import {
    ALTERNATEROW_BACKGROUND_COLOR,
    BLUE_COLOR, LIGHTGRAY_COLOR,
    MODIFIEDBLACK,
    PINK_COLOR,
    PROTECT_GREEN,
    RED_COLOR,
    VIBRANT_GREEN
} from "../constants";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import List from "@material-ui/core/List";
import renderIf from 'render-if';
import { Redirect } from "react-router-dom";
import { fnPostapiResponse, fnGETapiResponse, getUsername, Fnencryption } from '../APICall';


const StyledTabs = withStyles({
    indicator: {
        display: 'flex',
        backgroundColor: 'white',
        height: 3
    },
}, { index: 1 })((props) => <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />);

const StyledTab = withStyles((theme) => ({
    root: {
        textTransform: 'none',
        color: 'white',
        fontWeight: theme.typography.fontWeightRegular,
        fontSize: theme.typography.pxToRem(15),
        '&:focus': {
            opacity: 1
        }
    },
}, { index: 1 }))((props) => <Tab disableRipple {...props} />);

export default class ViewPendingRequest extends Component {

    state = {
        pages: 0,
        pages1: 0,
        current: 1,
        current1: 1,
        records: 0,
        records1: 0,
        pageSize: 10,
        showPager: false,
        showPager1: false,
        expanded: false, isloading: false,
        policynum: "policy type",
        period: "all",
        status: "all",
        anchorEl: null,
        open: false,
        ishovered: false,
        hoverindex: 0,
        showDialog: false,
        tabsvalue: 0,
        addpolicyholder: false,
        editinfo: false,
        tablebuffer: [
        ],
        pagesObj: [],
        pagesObj1: [],
        startDate: this.getTodaydate(),
        endDate: this.getTodaydate(),
        selectedStatus: "All",
        selectedDepart: "Claims",
        displaypolicydetails: 'none',
        detailsHeader: "",
        displayFlowdetails: "none",
        eloworkflowtitle: '',
        tableflowbuffer: [],
        showActionDialog: false,
        tablebufferaactionResult:[]
    }
    componentDidMount() {
        sessionStorage.setItem("isRBMRedirectfromAML", "")
        this.loadpendingData("")
        this.getTodaydate()
    }
    loadrowdata(POLICY_NO) {
        var data =
        {
            "MAPIURL": "" + process.env.REACT_APP_SOURCE_URL + "",
            "MAPINAME": 'GetPolicyDetails',
            "MAPIPORT": process.env.REACT_APP_MPORT,
            "body": { "POLICY_NO": POLICY_NO }

        }
        fnPostapiResponse(process.env.REACT_APP_SOURCE_URL_MIDDLEWARE, 'PostApiMiddleWare', data, process.env.REACT_APP_PORT_MIDDLEWARE).then((response) => {
            var rowObj = response.data[0][0]
            console.log("Row ka data", rowObj)
            if (rowObj != undefined) {
                this.setState({
                    rowPolicyNo: rowObj.POLICY_NO,
                    rowPolicyHolder: rowObj.SURNAME + " " + rowObj.FORENAMES,
                    rowPolicydate: rowObj.POLICY_DATE,
                    rowpolicytype: "",
                    rowMaturitydate: rowObj.MATURITY_DATE,
                    rowSumassured: rowObj.BASIC_SUM_ASSURD,
                    rowRowPreminum: rowObj.BASIC_PREMIUM,
                    showDialog: true,
                    detailsHeader: "POLICY HOLDER DETAILS",
                    displaypolicydetails: 'block',
                    displayFlowdetails: 'none',

                    // TRANSUSER:rowObj['USERID'],
                    // LINEOFCONTROL:rowObj['LINE_OF_CONTROL'],
                    // SURNAME:rowObj['SNAME'],
                    // REMARK:rowObj['REMK1'],
                    // NICTEXT:rowObj['NIC'],
                    // selectedCountry:rowObj['NIC_CNTRY'],
                })
            }
            else {
                alert("Record does not exist.")
            }
        }).catch(e => console.log(e));
    }
    formatedate(date) {
        var g = date.replace("-", "").replace("-", "")
        return g
    }
    pageChange(number) {
        this.state.current = number;
        var data = this.state.alldata.slice(this.state.current * this.state.pageSize, (this.state.current + 1) * this.state.pageSize);
        this.setState({ tablebuffer: data })

        this.state.pagesObj = [];
        if (this.state.pages < 10) {
            for (var i = 0; i < this.state.pages; i++)
                this.state.pagesObj.push(i);
        }
        else {
            var min = this.state.current - 5;
            var max = this.state.current + 5;
            if (min < 0)
                min = 0;
            if (max > this.state.pages)
                max = this.state.pages;
            if (max - min > 10) {
                min = this.state.current - 5;
                max = this.state.current + 5;
            }
            if (min > 0)
                this.state.pagesObj.push(0);
            for (var i = min; i < max; i++)
                this.state.pagesObj.push(i);
            if (max < this.state.pages - 1)
                this.state.pagesObj.push(this.state.pages - 1);
        }
    }
    pageChange1(number) {
        this.state.current1 = number;
        var data = this.state.alldata1.slice(this.state.current1 * this.state.pageSize, (this.state.current1 + 1) * this.state.pageSize);
        this.setState({ tablebufferaactionResult: data })

        this.state.pagesObj1 = [];
        if (this.state.pages1 < 10) {
            for (var i = 0; i < this.state.pages1; i++)
                this.state.pagesObj1.push(i);
        }
        else {
            var min = this.state.current1 - 5;
            var max = this.state.current1 + 5;
            if (min < 0)
                min = 0;
            if (max > this.state.pages1)
                max = this.state.pages1;
            if (max - min > 10) {
                min = this.state.current1 - 5;
                max = this.state.current1 + 5;
            }
            if (min > 0)
                this.state.pagesObj1.push(0);
            for (var i = min; i < max; i++)
                this.state.pagesObj1.push(i);
            if (max < this.state.pages1 - 1)
                this.state.pagesObj1.push(this.state.pages1 - 1);
        }
    }
    renderpages() {
        this.state.records = this.state.alldata.length;
        this.state.pages = parseInt(this.state.records / this.state.pageSize)
        if (this.state.records % this.state.pageSize > 0)
            this.state.pages++;
        this.state.showPager = this.state.pages > 1
        this.pageChange(0)
    }
    renderpages1() {
        this.state.records1 = this.state.alldata1.length;
        this.state.pages1 = parseInt(this.state.records1 / this.state.pageSize)
        if (this.state.records1 % this.state.pageSize > 0)
            this.state.pages1++;
        this.state.showPager1 = this.state.pages1 > 1
        this.pageChange1(0)
    }
    getTodaydate() {
        var d = new Date();
        var month = d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1
        var date1 = d.getDate() < 10 ? "0" + (d.getDate()) : d.getDate()
        var CMLSELECTEDATE = d.getFullYear() + "-" + month + "-" + date1
        this.setState({
            startDate: CMLSELECTEDATE,
            endDate: CMLSELECTEDATE
        })
        return CMLSELECTEDATE
    }
    fetchActionDetails(row) {
        var data =
        {
            "MAPIURL": "" + process.env.REACT_APP_SOURCE_URL + "",
            "MAPINAME": 'PendingActivityList',
            "MAPIPORT": process.env.REACT_APP_MPORT,
            "body": {
                "activity_name": row['wf_name']

            }
        }
        fnPostapiResponse(process.env.REACT_APP_SOURCE_URL_MIDDLEWARE, 'PostApiMiddleWare', data, process.env.REACT_APP_PORT_MIDDLEWARE).then((response) => {
            console.log("Activity ka data", response.data)
            var newdata;
            if (response.data["nPendingActList"] != undefined) {
                newdata = response.data["nPendingActList"]
                this.setState({ showActionDialog: true })
                this.setState({ alldata1: newdata, isloading: false })
                // console.log("Data :- ", this.state.alldata1)

                this.renderpages1()
            }

        }).catch(e => console.log(e));

        console.log("cliclRowDetailsrow", row)
    }
    fetchDetails(rowObj) {
        if (rowObj['submit_runtime_error'] == -4) {
            var r = window.confirm("Do you want to resubmit policy? You have to submit it manually from ELO.")
            if (r) {
                console.log("FinalRow", rowObj)
                this.updateError(rowObj['policy_no'], rowObj['request_id'])
            }
        } else
            if (rowObj['submit_runtime_error'] != 0) {
                var r = window.confirm("Are you sure you want to resubmit ?")
                if (r) {
                    console.log("FinalRow", rowObj)
                    this.updateError(rowObj['policy_no'], rowObj['request_id'])
                }
            }
    }
    fetchDetails1(rowObj) {
        var flowid = rowObj['elo_flow_id']
        if (flowid == 0)
            this.loadrowdata(rowObj['policy_no'])
        else {
            this.loadflowdata(rowObj['elo_flow_id'])
            this.setState({ eloworkflowtitle: rowObj['elo_flow_name'] });
        }
        // POST request using fetch with error handling
    }
    loadflowdata(flowid) {
        var data =
        {
            "MAPIURL": "" + process.env.REACT_APP_SOURCE_URL + "",
            "MAPINAME": 'getWorkflow',
            "MAPIPORT": process.env.REACT_APP_MPORT,
            "body": { "wflowid": flowid }
        }
        fnPostapiResponse(process.env.REACT_APP_SOURCE_URL_MIDDLEWARE, 'PostApiMiddleWare', data, process.env.REACT_APP_PORT_MIDDLEWARE).then((response) => {
            var rowObj = response.data['nWorkflowDetails']
            console.log("Row ka data", rowObj)
            if (rowObj != undefined) {
                this.setState({
                    showDialog: true,
                    detailsHeader: "Workflow Details",
                    displaypolicydetails: 'none',
                    displayFlowdetails: 'block',
                    tableflowbuffer: rowObj

                    // TRANSUSER:rowObj['USERID'],
                    // LINEOFCONTROL:rowObj['LINE_OF_CONTROL'],
                    // SURNAME:rowObj['SNAME'],
                    // REMARK:rowObj['REMK1'],
                    // NICTEXT:rowObj['NIC'],
                    // selectedCountry:rowObj['NIC_CNTRY'],
                })
            }
            else {
                alert("Record does not exist.")
            }
        }).catch(e => console.log(e));
    }
    updateError(Policy_no, reqId) {
        var data =
        {
            "MAPIURL": "" + process.env.REACT_APP_SOURCE_URL + "",
            "MAPINAME": 'Updateruntimeerror',
            "MAPIPORT": process.env.REACT_APP_MPORT,
            "body": {
                "Policy_no": Policy_no,
                "Request_id": reqId
            }

        }
        fnPostapiResponse(process.env.REACT_APP_SOURCE_URL_MIDDLEWARE, 'PostApiMiddleWare', data, process.env.REACT_APP_PORT_MIDDLEWARE).then((response) => {
            console.log("errorupdate")
            alert(response.data)
            this.loadpendingData(this.state.selectedStatus)
        }).catch(e => console.log(e));
    }
    loadpendingData(tasktype) {
        this.state.isloading = true
        if (tasktype != 'PENDINGACTIVITYCOUNT') {
            this.setState({
                columnvisibleStatus: "",
                columnvisiblePending: "none"
            })
            var startingdate = this.formatedate(this.state.startDate)
            var endingDate = this.formatedate(this.state.endDate)
            var data =
            {
                "MAPIURL": "" + process.env.REACT_APP_SOURCE_URL + "",
                "MAPINAME": 'getMyRequests',
                "MAPIPORT": process.env.REACT_APP_MPORT,
                "body": {
                    "userid": 1596,
                    "startdate": startingdate,
                    "ISADMIN": sessionStorage.getItem('isadminFlag'),
                    "enddate": endingDate
                }
            }
            fnPostapiResponse(process.env.REACT_APP_SOURCE_URL_MIDDLEWARE, 'PostApiMiddleWare', data, process.env.REACT_APP_PORT_MIDDLEWARE).then((response) => {
                console.log("ddd", response.data)
                var newdata;
                if (response.data["nRequestDetails"] != undefined) {
                    if (tasktype == "All" || tasktype == "")
                        newdata = response.data["nRequestDetails"]
                    else
                        newdata = response.data["nRequestDetails"].filter(item => item.status === tasktype)
                    for (var i = 0; i < newdata.length; i++) {
                        newdata[i].id = i
                    }

                    this.setState({ alldata: newdata, isloading: false })
                    console.log("Data :- ", this.state.alldata)

                    this.renderpages()
                    return
                }

                else {
                    this.setState({ alldata: [], isloading: false })
                    this.renderpages()
                    alert(response.data)
                    return
                }

            }).catch(e => console.log(e));
        }
        else {
            this.setState({
                columnvisibleStatus: "none",
                columnvisiblePending: "",
            })
            var data1 =
            {
                "MAPIURL": "" + process.env.REACT_APP_SOURCE_URL + "",
                "MAPINAME": 'GetPenActivityCases',
                "MAPIPORT": process.env.REACT_APP_MPORT,
                "body": ""
            }
            fnGETapiResponse(process.env.REACT_APP_SOURCE_URL_MIDDLEWARE, 'GetApiMiddleWare', data1, process.env.REACT_APP_PORT_MIDDLEWARE).then((response) => {
                console.log("dddss", response.data)
                var newdata;
                if (response.data["nPendingActivityCases"] != undefined) {
                    newdata = response.data["nPendingActivityCases"]
                    for (var i = 0; i < newdata.length; i++) {
                        newdata[i].id = i
                    }

                    this.setState({ alldata: newdata, isloading: false })
                    console.log("Data :- ", this.state.alldata)

                    this.renderpages()
                    return
                }

                else {
                    this.setState({ alldata: [], isloading: false })
                    this.renderpages()
                    alert(response.data)
                    return
                }


            }).catch(e => console.log(e));
        }

    }
    handleClick(event) {
        this.setState({ anchorEl: event.currentTarget, open: !this.state.open });
    };
    getParsedDate(strDate) {
        var strSplitDate = String(strDate).split(' ');
        var date = new Date(strSplitDate[0]);

        // alert(date);
        var dd = date.getDate();
        var mm = date.getMonth() + 1; //January is 0!

        var yyyy = date.getFullYear();
        if (dd < 10) {
            dd = '0' + dd;
        }
        if (mm < 10) {
            mm = '0' + mm;
        }
        date = dd + "-" + mm + "-" + yyyy;
        return date.toString();
    }
    handleClose() {
        this.setState({ anchorEl: null, open: !this.state.open, addpolicyholder: true });
    };

    handleChangeTabs(value) {
        this.setState({ tabsvalue: value });
    }
    submitRuntimeError(errorstatus) {
        var errorcolor = ''
        if (errorstatus != 0 && (errorstatus != -4)) { errorcolor = "red" }
        else if (errorstatus == -4) {
            errorcolor = "orange"
        }
        return errorcolor
    }

    /***
     *
     * @param n
     * @returns true if even number
     * @returns false if odd number
     */
    isEven(n) {
        return n % 2 == 0;
    }



    render() {
        return (
            <Fragment>
                {this.state.addpolicyholder && <Redirect to="/Addpolicyholder" />}
                {this.state.editinfo && <Redirect to="/Editpolicyholder" />}
                <Navigationmenu selectedMenu={'view_pending_requests'} />
                <Box
                    display="flex"
                    style={{ marginTop: '10vh' }}
                    alignItems="center"
                    justifyContent="center"
                >



                </Box>
                <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    style={{ marginTop: 35 }}
                >

                    <Paper elevation={2} style={{ minHeight: 100, width: '90%', borderRadius: 6 }}>

                        <Box
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                        >

                            <div style={{ minHeight: 100, width: '98%', borderRadius: 6 }}>

                                <Grid container spacing={2}>
                                    <Grid item xs={11}>
                                        <div style={{
                                            display: 'flex',
                                            marginBottom: 20,
                                            marginTop: 20
                                        }}>
                                            <Typography style={{ borderWidth: 0, color: BLUE_COLOR, textTransform: 'uppercase', fontFamily: 'Globerbold', fontSize: 20, paddingLeft: 10 }}>
                                                VIEW PENDING REQUESTS</Typography>
                                        </div>
                                    </Grid>
                                </Grid>
                                <Grid container spacing={2}>
                                    <Grid item xs={2}>
                                        <FormControl style={{ margin: 10, width: '100%' }}>
                                            <InputLabel id="demo-simple-select-helper-label">Company</InputLabel>
                                            <Select
                                                labelId="demo-simple-select-helper-label"
                                                id="demo-simple-select-helper"
                                                value="SWAN LIFE"

                                            >
                                                <MenuItem value={''}>No Filter</MenuItem>
                                                {/* {this.state.clinicdropData.map(team => (
                <MenuItem value={(team.ClinicName).trim()}>{team.ClinicName}</MenuItem>
              ))} */}
                                                <MenuItem value={'SWAN LIFE'}>SWAN LIFE</MenuItem>
                                                <MenuItem value={'SWAN GENERAL'}>SWAN GENERAL</MenuItem>
                                            </Select>
                                            {/* <FormHelperText>Choose a clinic from this dropdown.</FormHelperText> */}
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={2}>

                                        <FormControl style={{ margin: 10, width: '100%' }}>
                                            <InputLabel id="demo-simple-select-helper-label">Department</InputLabel>
                                            <Select
                                                labelId="demo-simple-select-helper-label"
                                                id="demo-simple-select-helper"
                                                value={this.state.selectedDepart}
                                                onChange={e => this.setState({ selectedDepart: e.target.value })}
                                            >
                                                <MenuItem value={'Claims'}>Claims</MenuItem>
                                                <MenuItem value={"Pending"}>Group Credit</MenuItem>
                                                <MenuItem value={'Finance'}>Finance</MenuItem>
                                            </Select>
                                            {/* <FormHelperText>Choose a Clinic first then apply this filter.</FormHelperText> */}
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={3}>

                                        <FormControl style={{ margin: 10, width: '90%' }}>
                                            <InputLabel id="demo-simple-select-helper-label">Task Type</InputLabel>
                                            <Select
                                                labelId="demo-simple-select-helper-label"
                                                id="demo-simple-select-helper"
                                                value={this.state.selectedStatus}
                                                onChange={e => this.setState({ selectedStatus: e.target.value },
                                                    this.loadpendingData(e.target.value))}
                                            >
                                                <MenuItem value={'All'}>ALL</MenuItem>
                                                <MenuItem value={"Pending"}>PENDING</MenuItem>
                                                <MenuItem value={'Completed'}>COMPLETED</MenuItem>
                                                <MenuItem value={'Submitted'}>SUBMITTED</MenuItem>
                                                <MenuItem value={'Submission in progress'}>SUBMISSION IN PROGRESS </MenuItem>
                                                <MenuItem value={'PENDINGACTIVITYCOUNT'}>PENDING BY ACTIVITY COUNT</MenuItem>
                                            </Select>
                                            {/* <FormHelperText>Choose a Clinic first then apply this filter.</FormHelperText> */}
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={2}>

                                        <ButtonGroup style={{ marginLeft: -25 }} color="primary" aria-label="outlined primary button group">
                                            <TextField fullWidth id="date" label="Start date"
                                                value={this.state.startDate}
                                                type="date"
                                                className="form-control"
                                                onChange={e => (this.setState({
                                                    startDate: e.target.value
                                                }
                                                    // , this.loadpendingData(this.state.selectedStatus)
                                                ))}
                                                inputProps={{
                                                    max: "" + this.state.todayDate + ""
                                                }}
                                                InputLabelProps={{ style: { fontFamily: 'Globerbold' } }}
                                            />
                                            <TextField fullWidth
                                                style={{ marginLeft: 10 }}
                                                id="date" label="End date"
                                                value={this.state.endDate}
                                                type="date"
                                                className="form-control"
                                                onChange={e => (this.setState({
                                                    endDate: e.target.value
                                                }
                                                    // ,this.loadpendingData(this.state.selectedStatus)
                                                ))}
                                                inputProps={{
                                                    max: "" + this.state.todayDate + ""
                                                }}
                                            // InputLabelProps={{ style: { fontFamily: 'Globerbold' } }}
                                            />
                                        </ButtonGroup>
                                    </Grid>


                                    <Grid item xs={2}>



                                        <Button variant={'contained'}
                                            style={{ marginTop: 0, width: '120px', height: '50px', marginLeft: 150, fontSize: "14px" }}
                                            onClick={e =>
                                                this.loadpendingData(this.state.selectedStatus)} >
                                            Reload data
                                        </Button>

                                    </Grid>
                                </Grid>

                                <TableContainer>
                                    <Table aria-label="table">
                                        <TableHead style={{ backgroundColor: 'rgba(241,241,241,1.0)' }}>
                                            <TableRow>
                                                <TableCell style={{ borderWidth: 0, width: "150px", color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold', display: this.state.columnvisibleStatus }} align="center">Request No</TableCell>
                                                <TableCell style={{ borderWidth: 0, width: "120px", color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold', display: this.state.columnvisibleStatus }} align="center">Document</TableCell>
                                                <TableCell style={{ borderWidth: 0, color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold', display: this.state.columnvisibleStatus }} align="center">Submitted By</TableCell>
                                                <TableCell style={{ borderWidth: 0, color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold', display: this.state.columnvisibleStatus }} align="center">Request Date</TableCell>
                                                <TableCell style={{ borderWidth: 0, color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold', display: this.state.columnvisibleStatus }} align="center">POLICY</TableCell>
                                                <TableCell style={{ borderWidth: 0, color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold', display: this.state.columnvisibleStatus }} align="center">Purpose</TableCell>
                                                <TableCell style={{ borderWidth: 0, width: "190px", color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold', display: this.state.columnvisibleStatus }} align="center">STATUS</TableCell>
                                                <TableCell style={{ borderWidth: 0, width: "220px", color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold', display: this.state.columnvisiblePending }} align="center">Name</TableCell>
                                                <TableCell style={{ borderWidth: 0, width: "120px", color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold', display: this.state.columnvisiblePending }} align="center">Count</TableCell>
                                                <TableCell style={{ borderWidth: 0, width: "120px", color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold', display: this.state.columnvisiblePending }} align="center">oldest</TableCell>
                                                <TableCell style={{ borderWidth: 0, width: "120px", color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold', display: this.state.columnvisiblePending }} align="center">latest</TableCell>

                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {!this.state.isloading ?
                                                this.state.tablebuffer.map((obj, index) => {
                                                    var rowbackgroundColor = 'white';
                                                    if (this.isEven(index)) { rowbackgroundColor = ALTERNATEROW_BACKGROUND_COLOR; }

                                                    if (this.state.ishovered && this.state.hoverindex == index) { rowbackgroundColor = LIGHTGRAY_COLOR }
                                                    if (obj != undefined) {
                                                        return (
                                                            <TableRow style={{ cursor: 'pointer' }} key={index} hover={true} onMouseOut={() => this.setState({ ishovered: false })} onMouseEnter={() => this.setState({ hoverindex: index, ishovered: true })}>
                                                                <TableCell style={{ borderWidth: 0, color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor, display: this.state.columnvisibleStatus }} align="center"><Typography style={{ textTransform: 'uppercase', fontSize: '14px', fontFamily: 'Globerbold' }} onClick={(e) => this.fetchDetails1(obj)}>{obj.request_id}</Typography></TableCell>
                                                                <TableCell style={{ borderWidth: 0, color: BLUE_COLOR, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor, display: this.state.columnvisibleStatus }} align="center"><Typography style={{ textTransform: 'uppercase', fontSize: '14px', fontFamily: 'Globerbold' }} onClick={(e) => this.fetchDetails1(obj)}> <FileCopy style={{ height: 32, width: 32, marginLeft: 5, marginTop: 5 }} /></Typography></TableCell>
                                                                <TableCell style={{ borderWidth: 0, color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor, display: this.state.columnvisibleStatus }} align="center"><Typography style={{ textTransform: 'uppercase', fontSize: '14px', fontFamily: 'Globerbold' }} onClick={(e) => this.fetchDetails1(obj)}>{obj.login_name}</Typography></TableCell>
                                                                <TableCell style={{ borderWidth: 0, color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor, display: this.state.columnvisibleStatus }} align="center"><Typography style={{ textTransform: 'uppercase', fontSize: '14px', fontFamily: 'Globerbold' }} onClick={(e) => this.fetchDetails1(obj)}>{obj.request_date}</Typography></TableCell>
                                                                <TableCell style={{ borderWidth: 0, color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor, display: this.state.columnvisibleStatus }} align="center"><Typography style={{ textTransform: 'uppercase', fontSize: '14px', fontFamily: 'Globerbold' }} onClick={(e) => this.fetchDetails1(obj)}>{obj.policy_no}</Typography></TableCell>
                                                                <TableCell style={{ borderWidth: 0, color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor, display: this.state.columnvisibleStatus }} align="center"><Typography style={{ textTransform: 'uppercase', fontSize: '14px', fontFamily: 'Globerbold' }} onClick={(e) => this.fetchDetails1(obj)}>{obj.purpose}</Typography></TableCell>
                                                                <TableCell style={{ borderWidth: 0, color: obj.statuscolor, textTransform: 'uppercase', fontFamily: 'Globerbold', color: this.submitRuntimeError(obj.submit_runtime_error), backgroundColor: rowbackgroundColor, display: this.state.columnvisibleStatus }} align="center"><Typography style={{ textTransform: 'uppercase', fontSize: '14px', fontFamily: 'Globerbold' }} onClick={(e) => this.fetchDetails(obj)}> {obj.status}</Typography></TableCell>
                                                                <TableCell style={{ borderWidth: 0, color: obj.statuscolor, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor, display: this.state.columnvisiblePending }} align="center" onClick={(e) => this.fetchActionDetails(obj)}>{obj.wf_name}</TableCell>
                                                                <TableCell style={{ borderWidth: 0, color: obj.statuscolor, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor, display: this.state.columnvisiblePending }} align="center">{obj.count}</TableCell>
                                                                <TableCell style={{ borderWidth: 0, color: obj.statuscolor, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor, display: this.state.columnvisiblePending }} align="center">{obj.oldest}</TableCell>
                                                                <TableCell style={{ borderWidth: 0, color: obj.statuscolor, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor, display: this.state.columnvisiblePending }} align="center">{obj.latest}</TableCell>
                                                            </TableRow>
                                                        )
                                                    }
                                                })
                                                : <td style={{ marginLeft: "500px", height: "100px" }}>
                                                    {/* Loading.... <CircularProgress classes="CircularProgress" /> */}
                                                    <img style={{ width: "100px" }} src={circulargridimage} alt="circulargridimage" />;
                                                </td>}
                                        </TableBody>
                                    </Table>
                                    <div style={this.state.showPager ? { height: 60, marginLeft: "500px", color: MODIFIEDBLACK, fontSize: "15px", textTransform: 'uppercase', fontFamily: 'Globerbold', wordBreak: "break-word" } : { display: "none" }} >
                                        {
                                            this.state.pagesObj.map((obj, index) => {
                                                return (
                                                    <span style={{ padding: "0 3px", cursor: "pointer" }}>
                                                        <a style={this.state.current == obj ? { fontWeight: 'bold', color: BLUE_COLOR, fontSize: "30px" } : {}} onClick={() => this.pageChange(obj)} >{obj + 1}</a>
                                                    </span>
                                                )
                                            })
                                        }
                                    </div>
                                </TableContainer>

                                <div style={{ height: 40 }} />
                            </div>

                        </Box>

                    </Paper>

                </Box>

                <div style={{ height: 50 }} />


                <Dialog fullScreen style={{ borderRadius: 0 }} maxWidth={'lg'} onClose={() => this.setState({ showDialog: false })} aria-labelledby="customized-dialog-title" open={this.state.showDialog}>

                    <Box
                        display="flex"
                        style={{ marginTop: 20 }}
                        alignItems="center"
                        justifyContent="center"
                    >
                        <div style={{ width: '94%' }}>
                            <AppBar className={{ position: 'relative' }}>
                                <Toolbar onClick={() => this.setState({ showDialog: false })}>
                                    <IconButton edge="start" color="inherit" aria-label="close">
                                        <CloseIcon />
                                    </IconButton>
                                    <Typography style={{ fontFamily: 'Globerbold', flexGrow: 1, fontSize: 24, textTransform: 'uppercase' }}>
                                        {this.state.detailsHeader}
                                    </Typography>
                                </Toolbar>
                            </AppBar>
                            <div style={{ display: this.state.displaypolicydetails }}>
                                <Grid container={3} spacing={3}>
                                    <Grid item xs={12}>

                                        <div style={{ marginTop: 60, marginLeft: 20 }}>
                                            <TableContainer>
                                                <Table aria-label="table">
                                                    <TableHead style={{ backgroundColor: 'rgba(241,241,241,1.0)' }}>
                                                        <TableRow>
                                                            <TableCell style={{ borderWidth: 0, color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold', display: this.state.columnvisibleStatus }} align="center">Policy No.</TableCell>
                                                            <TableCell style={{ borderWidth: 0, width: "150px", color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold', display: this.state.columnvisibleStatus }} align="center">Policy Holder</TableCell>
                                                            <TableCell style={{ borderWidth: 0, color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold', display: this.state.columnvisibleStatus }} align="center">Policy Date</TableCell>
                                                            <TableCell style={{ borderWidth: 0, color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold', display: this.state.columnvisibleStatus }} align="center">Policy Type</TableCell>
                                                            <TableCell style={{ borderWidth: 0, color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold', display: this.state.columnvisibleStatus }} align="center">Maturity Date</TableCell>
                                                            <TableCell style={{ borderWidth: 0, color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold', display: this.state.columnvisibleStatus }} align="center">Sum Assured</TableCell>
                                                            <TableCell style={{ borderWidth: 0, color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold', display: this.state.columnvisibleStatus }} align="center">Premium</TableCell>

                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>

                                                        <TableRow style={{ cursor: 'pointer' }} >
                                                            <TableCell style={{ borderWidth: 0, color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold' }} align="center">{this.state.rowPolicyNo}</TableCell>
                                                            <TableCell style={{ borderWidth: 0, color: MODIFIEDBLACK, whiteSpace: 'unset', textTransform: 'uppercase', fontFamily: 'Globerbold' }} align="center">{this.state.rowPolicyHolder}</TableCell>
                                                            <TableCell style={{ borderWidth: 0, color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold' }} align="center">{this.state.rowPolicydate}</TableCell>
                                                            <TableCell style={{ borderWidth: 0, color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold' }} align="center">{this.state.rowpolicytype}</TableCell>
                                                            <TableCell style={{ borderWidth: 0, color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold' }} align="center">{this.state.rowMaturitydate}</TableCell>
                                                            <TableCell style={{ borderWidth: 0, color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold' }} align="center">{this.state.rowSumassured}</TableCell>
                                                            <TableCell style={{ borderWidth: 0, color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold' }} align="center">{this.state.rowRowPreminum}</TableCell>
                                                        </TableRow>

                                                    </TableBody>
                                                </Table>

                                            </TableContainer>
                                        </div>
                                    </Grid>

                                </Grid>
                            </div>
                            <div style={{ display: this.state.displayFlowdetails }}>
                                <Grid container={3} spacing={3}>
                                    <Grid item xs={12}>

                                        <div style={{ marginTop: 60, marginLeft: 20 }}>
                                            <Typography style={{ fontFamily: 'Globerbold', flexGrow: 1, fontSize: 24, textTransform: 'uppercase' }}>
                                                ELO WORKFLOW :  {this.state.eloworkflowtitle}
                                            </Typography>
                                            <TableContainer>
                                                <Table aria-label="table">
                                                    <TableHead style={{ backgroundColor: 'rgba(241,241,241,1.0)' }}>
                                                        <TableRow>
                                                            <TableCell style={{ whiteSpace: 'unset', borderWidth: 0, color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold', display: this.state.columnvisibleStatus }} align="center">SR.NO</TableCell>
                                                            <TableCell style={{ whiteSpace: 'unset', borderWidth: 0, color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold', display: this.state.columnvisibleStatus }} align="center">Task Description</TableCell>
                                                            <TableCell style={{ whiteSpace: 'unset', borderWidth: 0, color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold', display: this.state.columnvisibleStatus }} align="center">Staff</TableCell>
                                                            <TableCell style={{ whiteSpace: 'unset', borderWidth: 0, color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold', display: this.state.columnvisibleStatus }} align="center">Task Assigned</TableCell>
                                                            <TableCell style={{ whiteSpace: 'unset', borderWidth: 0, color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold', display: this.state.columnvisibleStatus }} align="center">Task Assumed</TableCell>
                                                            <TableCell style={{ whiteSpace: 'unset', borderWidth: 0, color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold', display: this.state.columnvisibleStatus }} align="center">UserName</TableCell>

                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>

                                                        {
                                                            this.state.tableflowbuffer.map((obj, index) => {
                                                                var rowbackgroundColor = 'white';
                                                                if (this.isEven(index)) { rowbackgroundColor = ALTERNATEROW_BACKGROUND_COLOR; }

                                                                if (this.state.ishovered && this.state.hoverindex == index) { rowbackgroundColor = LIGHTGRAY_COLOR }
                                                                if (obj != undefined) {
                                                                    return (
                                                                        <TableRow style={{ cursor: 'pointer' }} >
                                                                            <TableCell style={{ whiteSpace: 'unset', borderWidth: 0, color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor, display: this.state.columnvisibleStatus }} align="center">{index + 1}</TableCell>
                                                                            <TableCell style={{ whiteSpace: 'unset', borderWidth: 0, color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor, display: this.state.columnvisibleStatus }} align="center">{obj.wf_name}</TableCell>
                                                                            <TableCell style={{ borderWidth: 0, color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor, display: this.state.columnvisibleStatus }} align="center"></TableCell>
                                                                            <TableCell style={{ borderWidth: 0, color: obj.statuscolor, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor, display: this.state.columnvisibleStatus }} align="center">{obj.wf_activate}</TableCell>
                                                                            <TableCell style={{ borderWidth: 0, color: obj.statuscolor, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor, display: this.state.columnvisibleStatus }} align="center">{obj.wf_terminate}</TableCell>
                                                                            <TableCell style={{ borderWidth: 0, color: obj.statuscolor, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor, display: this.state.columnvisibleStatus }} align="center">{obj.user_alias}</TableCell>
                                                                        </TableRow>
                                                                    )
                                                                }
                                                            })
                                                        }

                                                    </TableBody>
                                                </Table>

                                            </TableContainer>
                                        </div>
                                    </Grid>

                                </Grid>
                            </div>

                            <div style={{ height: 10 }} />

                        </div>
                    </Box>


                </Dialog>
                <Dialog fullScreen style={{ borderRadius: 0 }} maxWidth={'lg'} onClose={() => this.setState({ showActionDialog: false })} aria-labelledby="customized-dialog-title" open={this.state.showActionDialog}>

                    <Box
                        display="flex"
                        style={{ marginTop: 20 }}
                        alignItems="center"
                        justifyContent="center"
                    >
                        <div style={{ width: '94%' }}>
                            <AppBar className={{ position: 'relative' }}>
                                <Toolbar onClick={() => this.setState({ showActionDialog: false })}>
                                    <IconButton edge="start" color="inherit" aria-label="close">
                                        <CloseIcon />
                                    </IconButton>
                                    <Typography style={{ fontFamily: 'Globerbold', flexGrow: 1, fontSize: 24, textTransform: 'uppercase' }}>
                                        Pending Activity List
                                    </Typography>
                                </Toolbar>
                            </AppBar>
                            <div >
                                <Grid container={3} spacing={3}>
                                    <Grid item xs={12}>

                                        <div style={{ marginTop: 60, marginLeft: 20 }}>
                                            <Typography style={{ fontFamily: 'Globerbold', flexGrow: 1, fontSize: 24, textTransform: 'uppercase' }}>
                                            </Typography>
                                            <TableContainer>
                                                <Table aria-label="table">
                                                    <TableHead style={{ backgroundColor: 'rgba(241,241,241,1.0)' }}>
                                                        <TableRow>
                                                            <TableCell style={{ whiteSpace: 'unset', borderWidth: 0, color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold' }} align="center">ProcessNAme</TableCell>
                                                            <TableCell style={{ whiteSpace: 'unset', borderWidth: 0, color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold' }} align="center">Username</TableCell>
                                                            <TableCell style={{ whiteSpace: 'unset', borderWidth: 0, color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold' }} align="center">Assigned</TableCell>
                                                            <TableCell style={{ whiteSpace: 'unset', borderWidth: 0, color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold' }} align="center">Assumed</TableCell>

                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>

                                                        {
                                                            this.state.tablebufferaactionResult.map((obj, index) => {
                                                                var rowbackgroundColor = 'white';
                                                                if (this.isEven(index)) { rowbackgroundColor = ALTERNATEROW_BACKGROUND_COLOR; }

                                                                if (this.state.ishovered && this.state.hoverindex == index) { rowbackgroundColor = LIGHTGRAY_COLOR }
                                                                if (obj != undefined) {
                                                                    return (
                                                                        <TableRow style={{ cursor: 'pointer' }} >
                                                                            <TableCell style={{ whiteSpace: 'unset', borderWidth: 0, color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor  }} align="center">{obj.wf_flow_name}</TableCell>
                                                                            <TableCell style={{ whiteSpace: 'unset', borderWidth: 0, color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor}} align="center">{obj.username}</TableCell>
                                                                            <TableCell style={{ borderWidth: 0, color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor }} align="center">{obj.Assigned}</TableCell>
                                                                            <TableCell style={{ borderWidth: 0, color: obj.statuscolor, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor }} align="center">{obj.Assumed}</TableCell>
                                                                        </TableRow>
                                                                    )
                                                                }
                                                            })
                                                        }

                                                    </TableBody>
                                                </Table>
                                                <div style={this.state.showPager1 ? { height: 60, marginLeft: "500px", color: MODIFIEDBLACK, fontSize: "15px", textTransform: 'uppercase', fontFamily: 'Globerbold', wordBreak: "break-word" } : { display: "none" }} >
                                                    {
                                                        this.state.pagesObj1.map((obj, index) => {
                                                            return (
                                                                <span style={{ padding: "0 3px", cursor: "pointer" }}>
                                                                    <a style={this.state.current1 == obj ? { fontWeight: 'bold', color: BLUE_COLOR, fontSize: "30px" } : {}} onClick={() => this.pageChange1(obj)} >{obj + 1}</a>
                                                                </span>
                                                            )
                                                        })
                                                    }
                                                </div>
                                            </TableContainer>
                                        </div>
                                    </Grid>

                                </Grid>
                            </div>

                            <div style={{ height: 10 }} />

                        </div>
                    </Box>


                </Dialog>
            </Fragment>
        )
    }
}
